export default "__VITE_ASSET__781b5ea7__"